import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroUsuario from '../../../actions/usuario/adicionarFiltroUsuario'
import removerFiltroUsuario from '../../../actions/usuario/removerFiltroUsuario'
import listarFiltrosUsuario from '../../../actions/usuario/listarFiltrosUsuario'
import {
    FILTRO_CPF,
    FILTRO_DATA_CRIACAO,
    FILTRO_EMAIL_USUARIO,
    FILTRO_NOME_USUARIO,
    FILTRO_TIPO_PLANO,
    FILTRO_NOME_AGENCIA,
    FILTRO_STATUS_USUARIO
} from '../../../util/filtros'
import FiltroBuscaUsuarioAgencia from './FiltroBuscaUsuarioAgencia';
import Autorizacao from '../../../security/Autorizacao';
import { PERFIL_ADMIN } from '../../../security/securityContext';

export class FiltroUsuarioAgencia extends Component {

    adicionarFiltro(filtro) {
        this.props.adicionarFiltroUsuario(filtro)
    }

    removerFiltro(filtro) {
        this.props.removerFiltroUsuario(filtro)
    }

    render() {
        return (
            <React.Fragment>
                <div className="conteudo">
                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                        <FiltroBuscaUsuarioAgencia
                            filtro={FILTRO_DATA_CRIACAO}
                            opcoes={[new Date().getFullYear()]}
                            isFiltroData={true}
                        />
                    </Autorizacao>
                    <FiltroBuscaUsuarioAgencia
                        filtro={FILTRO_CPF}
                        isCpf={true}
                    />
                    <FiltroBuscaUsuarioAgencia
                        filtro={FILTRO_NOME_USUARIO}
                        isNome={true}
                        opcoes={[]}
                    />
                    <FiltroBuscaUsuarioAgencia
                        filtro={FILTRO_EMAIL_USUARIO}
                        isEmail={true}
                        opcoes={[]}
                    />
                    <FiltroBuscaUsuarioAgencia
                        filtro={FILTRO_STATUS_USUARIO}
                        opcoes={['Ativo', 'Inativo']}
                        isRadio={true}
                    />
                    <FiltroBuscaUsuarioAgencia
                        filtro={FILTRO_TIPO_PLANO}
                        opcoes={this.props.tipoPlano.map(it => it.chave)}
                    />
                    <FiltroBuscaUsuarioAgencia
                        filtro={FILTRO_NOME_AGENCIA}
                        isNome={true}
                        opcoes={[]}
                    />
                </div>
            </React.Fragment>
        )
    }
}

export function mapStateToProps(state) {
    return {
        plataformas: state.plataformas,
        tipoPlano: state.usuarios.tipoPlanoDto || []

    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        adicionarFiltroUsuario,
        removerFiltroUsuario,
        listarFiltrosUsuario
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(FiltroUsuarioAgencia)
